import { getAvatar } from '~/constants';
import { showMessage } from '~/helper';
import { useHistory } from 'react-router-dom';
import api from '~/services/api';
import axios from 'axios';
import useGlobalContext from '~/view-data/use-global-context';

const initialState = {
  mode: 'login',
  loginData: {}
};

function useAuthPress() {
  const history = useHistory(),
    { state: { auth = initialState }, dispatch } = useGlobalContext();

  const changeMode = (mode) => {
    let loginData = (mode === 'signup') ? { country: 'Brasil' } : {};
    dispatch({ type: 'auth', payload: { mode, loginData } });
  };

  const loginSubmit = async (params, action) => {
     try {
      const { data } = await api.post('auth/login', params);
      loginSuccess(data);
    } catch (error) {
      action && action.setSubmitting(false);
      failure(error);
    }
  };

  const forgetPasswordSubmit = async (data, action) => {
    try {
      await api.post('auth/forget-password', data);

      showMessage('success', 'Senha redefinida com sucesso, verifique a caixa de entrada do seu email!');
      action.setSubmitting(false);
      changeMode('login');
    } catch (error) {
      action && action.setSubmitting(false);
      failure(error);
    }
  };

  const signUpSubmit = async (data, action) => {
    try {
      await api.post('auth/signup-press', data);

      showMessage('success', 'Cadastro realizado com sucesso, verifique a caixa de entrada do seu email!');
      action.setSubmitting(false);
      changeMode('login');
    } catch (error) {
      action && action.setSubmitting(false);
      failure(error);
    }
  };

  const getGravatarImage = async ({ emailMd5 }) => {
    let gravatarUrl = `https://gravatar.com/avatar/${emailMd5}?d=404`;
    try {
      let response = await axios.get(gravatarUrl, { responseType: 'blob' });
      return new Promise((resolve) => {
        let reader = new window.FileReader();
        reader.readAsDataURL(response.data);
        reader.onload = function() {
          resolve(reader.result);
        };
      });
    } catch(err) {
    }
    return null;
  };

  const loginSuccess = async ({ token, me, menu }) => {
    api.defaults.headers.Authorization = `Bearer ${token}`;
    let avatarBase64 = await getGravatarImage(me);
    me.avatar = getAvatar({ ...me, avatarBase64 });
    dispatch({ type: 'auth', persistent: true, payload: { signed: true, user: me, token, menu} });
    history.push('/home');
  };

  const failure = (error) => {
    dispatch({ type: 'auth', payload: { signed: false, isLoginMode: true } });
    showMessage('error', error)
  };

  return {
    state: {
      ...auth,
    },
    actions: {
      changeMode,
      loginSubmit,
      signUpSubmit,
      forgetPasswordSubmit,
    },
  };
}

export default useAuthPress;
